import React, { useState } from "react";
import axios from "axios";
import base_url from "../../api/bootapi";
import { ConnectingAirportsOutlined } from "@mui/icons-material";

const GoogleInputAdditonal = ({
  tripDetails,
  index,
  additionalPoint,
  setAdditionalPoint,
}) => {
  const [optionsList, setOptionsList] = useState([]);
  const [isOpenList, setIsOpenList] = useState(false);

  const fetchSuggestions = async (inputValue) => {
    if (!inputValue) {
      setOptionsList([]);
      return;
    }

    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/address_suggestion?address=${inputValue}`
      );
      const data = response.data;
      const suggestions = data.suggestions.map((suggestion) => ({
        label: suggestion.postal_code
          ? `${suggestion.description},${suggestion.postal_code}`
          : suggestion.description,
        value: suggestion.place_id,
      }));
      setOptionsList(suggestions);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setOptionsList([]);
    }
  };

  const handleAddressInputChange = async (e) => {
    fetchSuggestions(e.target.value);
    // const newStages = [...stages];
    // newStages[index][field] = e.target.value;
    // setStages(newStages);
    // setValue(e.target.value); // Assuming label is unique and used as field name
    setAdditionalPoint(e.target.value);
    setIsOpenList(true);
  };

  // const handleAddressChange = async (option) => {
  //   //console.log(option.label);
  //   const newStages = [...stages];
  //   newStages[index][field] = option.label;
  //   setStages(newStages);
  //   setValue(option.label);
  //   setOptionsList([]);
  //   setIsOpenList(false);
  // };

  const getDistance = async (origin, destination) => {
    try {
      const response = await axios.post(`${base_url.api1}/tourapp/distance`, {
        origins: origin,
        destinations: destination,
      });

      const distanceValue = response.data.data.distance.value;

      const kmDistance = distanceValue / 1000; // Convert to kilometers

      return kmDistance;
    } catch (error) {
      console.error(
        `Error fetching distance from ${origin} to ${destination}`,
        error
      );
      return 0; // Return false to indicate error
    }
  };

  // const handleCalculate = async () => {
  //   const from_loc = stages[index]["from_loc"];
  //   const additional_point = stages[index]["additional_point"];
  //   const to_loc = stages[index]["to_loc"];
  //   let totalDistance = 0;

  //   // if (!additional_point && !to_loc && ) {
  //   //   return;
  //   // }

  //   if (additional_point) {
  //     const from_to_additional_distance = await getDistance(
  //       from_loc,
  //       additional_point
  //     );
  //     const additional_to_to_distance = await getDistance(
  //       additional_point,
  //       to_loc
  //     );
  //     totalDistance =
  //       totalDistance + from_to_additional_distance + additional_to_to_distance;
  //   } else {
  //     const from_to_to_distance = await getDistance(from_loc, to_loc);
  //     totalDistance = totalDistance + from_to_to_distance;
  //   }
  //   const newStages = [...stages];
  //   newStages[index]["totalDistance"] = totalDistance;
  //   setStages(newStages);
  // };

  const handleInputBlur = async () => {
    //console.log("google input value", stages[index].field);
    // if (
    //   field === "to_loc" ||
    //   field === "from_loc" ||
    //   field === "additional_point"
    // ) {
    //   await handleCalculate();
    // }
    setTimeout(() => {
      setIsOpenList(false);
    }, 100);
  };

  return (
    <div>
      <div style={{ position: "relative" }}>
        <input
          value={additionalPoint}
          onChange={handleAddressInputChange}
          // className="search-input form-control"
          type="text"
          autoComplete="off"
          onBlur={handleInputBlur}
          onFocus={() => setIsOpenList(true)} // Open list when input is focused
          id="google_input_icon"
        />
        {/* <i
          className="fa fa-map-marker home_icon"
          style={{ position: "absolute", left: 15, top: 10 }}
        /> */}
        {/* <span
          id="google_input_icon"
          className="home_icon"
          style={{ position: "absolute", left: 15, top: 6 }}
        >
          {field === "from" ? "From:" : "To:"}
        </span> */}
        {isOpenList && optionsList.length > 0 && (
          <ul className="search-results" style={{ width: "100%" }}>
            {optionsList.map((option, index) => (
              <li
                key={index}
                onClick={() => {
                  setAdditionalPoint(option.label);
                  setOptionsList([]);
                  setIsOpenList(false);
                }}
                onMouseDown={(e) => e.preventDefault()}
              >
                {option.label}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default GoogleInputAdditonal;
